import React, { useEffect, useState } from "react";
import { Progress } from "reactstrap";
import useUpdate from "../../Hooks/useUpdate";
import Api from "../../Hooks/Api";
import { Link } from "react-router-dom";
const EditProfile = (props) => {
  const [message, setmessage] = useState("");
  const [inputs, setInputs] = useState({});
  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const url = "api/Users";
  const FetchAll = () => {
    Api.get("api/Users/" + window.sessionStorage.getItem("UserId"))
    .then(function (response) {
        setInputs(response.data);

    })
    .catch(function (error) {
        // handle error
        console.log(error);
    })
    .then(function () {
        // always executed
    })
  };
  useEffect(() => {
    FetchAll();
  }, []);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));
  };
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };

  const onChangeHandler = (event) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
    }
  };
  const onClickHandler = (event) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();

      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Api.post("/api/Upload", data, {
          onUploadProgress: (ProgressEvent) => {
            setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
          },
        })
        .then((res) => {
          if (res.status == "200") {
            setmessage("Uploaded successfully");
            setInputs((inputs) => ({ ...inputs, photo: res.data.dbPath }));
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };

  const HandleUpdate = () => {
    useUpdate(url + "/" + inputs.id, inputs);
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    HandleUpdate();
  };

  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">EditProfile</li>
      </ol>
      <h1 class="page-header mb-3">EditProfile</h1>
      <div style={{ backgroundColor: "white" }}>
        <br />
        <div className="container-fluid">
          <div className="col-sm-12">
            <div className="ibox-content">
              <form className="form-horizontal" onSubmit={HandleSubmit}>
                <div className=" row">
                  <div className="col-sm">
                    <div className="form-group">
                      <label htmlFor="Datereceived" className="fontWeight-bold">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        required
                        value={inputs.name}
                        onChange={handleInputChange}
                        // defaultvalue={inputs.name}
                      />
                    </div>
                  </div>
                  <div className="col-sm">
                    <div className="form-group">
                      <label htmlFor="Datereceived" className="fontWeight-bold">
                        UserName
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="userName"
                        required
                        value={inputs.userName}
                        onChange={handleInputChange}
                        // defaultvalue={inputs.name}
                      />
                    </div>
                  </div>
                </div>

                <div className=" row">
                  <div className="col-sm">
                    <div className="form-group">
                      <label htmlFor="Datereceived" className="fontWeight-bold">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        required
                        value={inputs.email}
                        onChange={handleInputChange}
                        // defaultvalue={inputs.name}
                      />
                    </div>
                  </div>
                  <div className="col-sm">
                    <div className="form-group">
                      <label htmlFor="Datereceived" className="fontWeight-bold">
                        Mobile
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="mobile"
                        required
                        value={inputs.mobile}
                        onChange={handleInputChange}
                        // defaultvalue={inputs.name}
                      />
                    </div>
                  </div>
                </div>
                <div className=" row">
                  {/* <div className="col-sm-6"> */}
                  <div className="col-sm">
                    <div className="form-group">
                      <label htmlFor="Datereceived" className="fontWeight-bold">
                        Photo
                      </label>
                      <div className="form-group">
                        <input
                          type="file"
                          className="form-control"
                          name="file"
                          onChange={onChangeHandler}
                          multiple
                        />
                        <div class="form-group">
                          <Progress max="100" color="success" value={loaded}>
                            {Math.round(loaded, 2)}%
                          </Progress>
                        </div>
                        <button
                          type="submit"
                          class="btn btn-success "
                          onClick={onClickHandler}
                        >
                          Upload
                        </button>
                        <span class="upload">{message}</span>
                      </div>
                    </div>
                  </div>
                  {/* </div>   */}
                  <div className="col-sm">
                    <div className="row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            name="password"
                            required
                            value={inputs.password}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm">
                    <div className="row">
                      <div className="col-sm-8"></div>
                      <div className="col-sm-4">
                        <div class="d-flex flex-row float-right">
                          <button className="btn btn-success p-2" type="submit">
                            Update
                          </button>
                          &nbsp;{" "}
                          <button className="btn btn-warning p-2" type="button">
                            Close
                          </button>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditProfile;
